export default __webpack_public_path__ + "fonts/success-icon.svg";